import type { ReactNode } from 'react';
import Header from '@/components/ui/header';

interface AppLayoutProps {
    children: ReactNode;
}

const AppLayout = ({ children }: AppLayoutProps) => {
    return (
        // The page was a blue→purple→pink gradient, which is not in the
        // palette at all. --brand-page is the flat surface the brand document
        // asks for; white cards sit on it at 1.18:1, which is why Card carries
        // a --brand-surface-edge border rather than relying on its fill.
        <div className="min-h-screen bg-brand-page">
            <Header />
            <main className="flex-1">{children}</main>
        </div>
    );
};

export default AppLayout;
